import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const MagneticButton = ({ to, href, children, variant = "solid", testid, className = "", type, onClick, disabled = false }) => {
  const ref = useRef(null);
  const x = useSpring(useMotionValue(0), { stiffness: 220, damping: 16 });
  const y = useSpring(useMotionValue(0), { stiffness: 220, damping: 16 });
  const move = (e) => {
    const r = ref.current.getBoundingClientRect();
    x.set((e.clientX - r.left - r.width / 2) * 0.25);
    y.set((e.clientY - r.top - r.height / 2) * 0.35);
  };
  const reset = () => { x.set(0); y.set(0); };
  const styles = variant === "solid"
    ? "bg-cream text-skaris-ink"
    : "border border-cream/30 text-cream hover:border-cream";
  const inner = (
    <>
      <span className={`absolute inset-0 origin-bottom scale-y-0 transition-transform duration-500 ease-[cubic-bezier(.16,1,.3,1)] group-hover:scale-y-100 ${variant === "solid" ? "bg-skaris-sky" : "bg-cream"}`} />
      <span className={`relative z-10 flex items-center gap-3 transition-colors duration-500 ${variant === "solid" ? "group-hover:text-white" : "group-hover:text-skaris-ink"}`}>
        {children}
        <span className="relative h-4 w-4 overflow-hidden">
          <ArrowUpRight className="absolute h-4 w-4 transition-transform duration-500 group-hover:-translate-y-4 group-hover:translate-x-4" />
          <ArrowUpRight className="absolute h-4 w-4 -translate-x-4 translate-y-4 transition-transform duration-500 group-hover:translate-x-0 group-hover:translate-y-0" />
        </span>
      </span>
    </>
  );
  const cls = `group relative inline-flex items-center overflow-hidden rounded-full px-7 py-4 font-body text-sm font-medium uppercase tracking-[0.14em] disabled:cursor-not-allowed disabled:opacity-60 ${styles} ${className}`;
  return (
    <motion.span ref={ref} style={{ x, y }} onMouseMove={move} onMouseLeave={reset} className="inline-block">
      {to ? (
        <Link to={to} data-testid={testid} className={cls}>{inner}</Link>
      ) : href ? (
        <a href={href} data-testid={testid} className={cls}>{inner}</a>
      ) : (
        <button type={type} onClick={onClick} data-testid={testid} className={cls} disabled={disabled}>{inner}</button>
      )}
    </motion.span>
  );
};
